import { cloneDeep } from "lodash";
import {
    allClassificationTypesOptions,
    allDataSourcesOptions,
    allMeasureUnitsOptions,
    allMutuallyRedeemingLevelOptions,
    allMutuallyRedeemingOptions,
    allPeriodicitiesOptions,
    allReportNamesOptions,
    allReportTypesOptions,
    allSegmentationOptions,
    allMonthsOptions,
    allComparedPeriods,
    allBudgetTypesOptions,
    allIncomeClassificators,
    allExpensesClassificators,
    allStatusOptionsExtended
} from "../../common/baseOptions";
import { Template } from "../../common/types/Template";
import { ReportReconStatementFilterSettings } from "./settings/ReportReconStatementFilterSettings";
import { ReportReconStatementFilterOptions } from "./options/ReportReconStatementFilterOptions";
import { Indicator } from "../../common/types/Indicator";
import { Option } from "../../common/types/Option";
import { ByForm, StatusType } from "../../common/types/roots/fields";


export const reportReconStatementIncomeIndicators: Indicator[] = [
    { key: 'god_ea', active: true },
    { key: 'mes_ea', active: true },
    { key: 'god127', active: true },
    { key: 'mes127', active: true },
    { key: 'dev_god', active: true },
    { key: 'dev_mes', active: true }
]
export const reportReconStatementExpenseIndicators: Indicator[] = [
    { key: 'plg', active: true },
    { key: 'obaz', active: true },
    { key: 'plat', active: true },
    { key: 'sum_oblig', active: true },
    { key: 'sum_payment', active: true },
    { key: 'obaz_dif', active: true },
    { key: 'plat_dif', active: true },
    { key: 'is_equal', active: true },
]
export const reportReconStatementStatusOptions: Option<StatusType>[] = cloneDeep(allStatusOptionsExtended)


// Нужна как временная затычка (При созданий нового берутся пустые настройки)
const tempSettings: ReportReconStatementFilterSettings = {
    // Base:
    reportName: 'RECON-STATEMENT',
    reportType: 'REGULATED',
    classificationType: 'INCOMES_OR_EXPENSES',
    dataSource: 'IISK',
    periodicity: 'MONTH',
    // Custom:
    date: '',
    budgetTypes: [],
    month: 1,
    year: (new Date()).getFullYear(),
    region: '',
    statuses: [],
    isTree: true,
    measureUnit: 'THOUSAND',
    roundUpTo: null,
    mutuallyRedeeming: 'ONLY',
    mutuallyRedeemingLevels: [],
    segmentations: [],
    incomeTotal: false,
    incomes: [],
    expenseTotal: false,
    expenses: [],
    indicators: cloneDeep(reportReconStatementIncomeIndicators),
    fillCbc: false,
    show_deviation_only: false,
    compared_period: allComparedPeriods[0],
    gu: null,
}

export const reportReconStatementBaseTemplate: Template = {
    id: null,
    name: 'Сверка планов по КФ',
    excelName: null,
    description: null,
    category: '55',
    regions: [],
    userId: '',
    filterSettings: tempSettings
}

export const reportReconStatementFilterOptions: ReportReconStatementFilterOptions = {
    // Base:
    key: 'RECON-STATEMENT',
    reportNames: cloneDeep(allReportNamesOptions),
    reportTypes: cloneDeep(allReportTypesOptions),
    periodicities: cloneDeep(allPeriodicitiesOptions),

    classificationTypes: cloneDeep(allClassificationTypesOptions.filter(it => it.value !== 'MIXED')),
    dataSources: cloneDeep(allDataSourcesOptions.filter(it => it.value !== 'MIXED')),
    // Custom:
    measureUnits: cloneDeep(allMeasureUnitsOptions),
    budgetTypes: cloneDeep(allBudgetTypesOptions).filter(it => it.value !== 1),
    regions: [], // Загружается с бэка
    mutuallyRedeeming: cloneDeep(allMutuallyRedeemingOptions),
    mutuallyRedeemingLevels: cloneDeep(allMutuallyRedeemingLevelOptions),
    statuses: cloneDeep(reportReconStatementStatusOptions),
    segmentations: cloneDeep(allSegmentationOptions),
    incomes: cloneDeep(allIncomeClassificators),
    expenses: cloneDeep(allExpensesClassificators),
    indicators: cloneDeep(reportReconStatementIncomeIndicators),
    months: cloneDeep(allMonthsOptions),
    comparedPeriods: cloneDeep(allComparedPeriods)
}
